<!-- T.32832 - Template para tracking del chofer -->
<div class="container-fluid tracking-chofer-container p-0">
  
  <!-- T.32832 - Header del chofer -->
  <div class="chofer-header">
    <div class="header-title">
      <i class="fas fa-truck mr-2"></i>
      Tracking Viajes
    </div>
    <div class="status-info">
      <div class="status-item" *ngIf="permisoUbicacion">
        <span class="status-label">Distancia:</span>
        <span class="distance-value">{{ formatearDistancia(distanciaGarita) }}</span>
      </div>
      <div class="header-buttons">
        <button class="btn btn-pdf btn-granel" (click)="abrirPdfGranel()" title="Descargar instructivo Granel">
          <i class="fas fa-file-pdf mr-1"></i>
          Granel
        </button>
        <button class="btn btn-pdf btn-contenerizado" (click)="abrirPdfContenerizado()" title="Descargar instructivo Contenerizado">
          <i class="fas fa-file-pdf mr-1"></i>
          Contenerizado
        </button>
      </div>
    </div>
  </div>


  <!-- T.32832 - Sección del mapa -->
  <div class="mapa-section-chofer">
    <!-- T.32832 - Loader mientras carga -->
    <div *ngIf="loading" class="mapa-loader">
      <div class="text-center">
        <div class="spinner-border text-primary" role="status">
          <span class="sr-only">Obteniendo ubicación...</span>
        </div>
        <p class="mt-2">Obteniendo tu ubicación GPS...</p>
      </div>
    </div>

    <!-- T.32832 - Mensaje cuando no hay permisos -->
    <div *ngIf="!loading && !permisoUbicacion" class="sin-permisos">
      <div class="text-center p-4">
        <i class="fas fa-map-marker-alt fa-4x text-muted mb-3"></i>
        <h5>Permisos de Ubicación Requeridos</h5>
        <p class="text-muted">Para usar esta aplicación necesitas permitir el acceso a tu ubicación GPS.</p>
        <button class="btn btn-primary" (click)="solicitarPermisoUbicacion()">
          <i class="fas fa-location-arrow mr-1"></i>
          Permitir Ubicación
        </button>
      </div>
    </div>

    <!-- T.32832 - Contenedor del mapa -->
    <div id="mapa-tracking" class="mapa-container-chofer" *ngIf="permisoUbicacion && !loading"></div>
  </div>

  <!-- T.32832 - Panel de información de viajes -->
  <div class="info-panel-chofer">
    <div class="info-header-chofer">
      <i class="fas fa-list mr-2"></i>
      Mis Viajes Activos
    </div>
    
    <div class="info-content-chofer">
      <!-- T.32832 - Grid de viajes -->
      <div class="viajes-grid-container">
        <ag-grid-angular
          #agGrid
          class="ag-theme-alpine"
          [rowData]="viajesData"
          [columnDefs]="columnDefs"
          [defaultColDef]="defaultColDef"
          [pagination]="true"
          [paginationPageSize]="15"
          [rowHeight]="35"
          [suppressHorizontalScroll]="false"
          [animateRows]="true"
          (gridReady)="onGridReady($event)">
        </ag-grid-angular>
      </div>

      <!-- T.32832 - Instrucciones (solo se muestran con permisos) -->
      <div class="instrucciones" *ngIf="permisoUbicacion && !enGeofence && viajesData.length > 0">
        <div class="alert alert-info">
          <i class="fas fa-info-circle mr-2"></i>
          <strong>Instrucciones:</strong> Selecciona un viaje de la tabla para ver su ubicación en el mapa. 
          Dirígete hacia el destino siguiendo la ruta marcada.
        </div>
      </div>

      <div class="instrucciones" *ngIf="permisoUbicacion && enGeofence">
        <div class="alert alert-success">
          <i class="fas fa-check-circle mr-2"></i>
          <strong>¡Has llegado!</strong> Te encuentras en la zona del destino. 
          Dirígete al punto de control con tu ticket: <strong>{{ ticketAsignado }}</strong>
        </div>
      </div>

      <!-- T.32832 - Mensaje cuando no hay viajes -->
      <div class="alert alert-warning" *ngIf="viajesData.length === 0 && !loadingViajes">
        <i class="fas fa-exclamation-triangle mr-2"></i>
        <strong>Sin viajes activos:</strong> No tienes viajes asignados en este momento.
      </div>

      <!-- T.32832 - Loader para viajes -->
      <div class="text-center" *ngIf="loadingViajes">
        <div class="spinner-border text-primary" role="status">
          <span class="sr-only">Cargando viajes...</span>
        </div>
        <p class="mt-2">Cargando tus viajes activos...</p>
      </div>
    </div>
  </div>
</div>
